export const FETCH_USERS_REQUEST = 'FETCH_USERS_REQUEST';
export const FETCH_USERS_SUCCESS = 'FETCH_USERS_SUCCESS';
export const FETCH_SHOP_BARBERS_SUCCESS = 'FETCH_SHOP_BARBERS_SUCCESS';
export const CLEAR_BARBERS_BY_SHOP = 'CLEAR_BARBERS_BY_SHOP';

export const UPDATE_USER_REQUEST = 'UPDATE_USER_REQUEST';
export const UPDATE_USER_SUCCESS = 'UPDATE_USER_SUCCESS';

export const SAVE_USER_REQUEST = 'SAVE_USER_REQUEST';
export const SAVE_USER_SUCCESS = 'SAVE_USER_SUCCESS';

export const FETCH_USER_REQUEST = 'FETCH_USER_REQUEST';
export const FETCH_USER_SUCCESS = 'FETCH_USER_SUCCESS';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';

export const FETCH_BRAND_USERS_REQUEST = 'FETCH_BRAND_USERS_REQUEST';
export const FETCH_BRAND_USERS_SUCCESS = 'FETCH_BRAND_USERS_SUCCESS';

export const FETCH_PERMISSIONS = 'FETCH_PERMISSIONS';

export const FETCH_BRAND_STAFF_USERS = 'FETCH_BRAND_STAFF_USERS';
export const RESET_BRAND_STAFF_USERS = 'RESET_BRAND_STAFF_USERS';
export const FETCH_BRAND_STAFF_USERS_SUCCESS = 'FETCH_BRAND_STAFF_USERS_SUCCESS';
